var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7916 8.74984H32.0833V11.6665H29.1666V30.6248C29.1666 31.4303 28.5137 32.0832 27.7083 32.0832H7.29163C6.48622 32.0832 5.83329 31.4303 5.83329 30.6248V11.6665H2.91663V8.74984H10.2083V4.37484C10.2083 3.56943 10.8612 2.9165 11.6666 2.9165H23.3333C24.1387 2.9165 24.7916 3.56943 24.7916 4.37484V8.74984ZM26.25 11.6665H8.74996V29.1665H26.25V11.6665ZM13.125 16.0415H16.0416V24.7915H13.125V16.0415ZM18.9583 16.0415H21.875V24.7915H18.9583V16.0415ZM13.125 5.83317V8.74984H21.875V5.83317H13.125Z",
    fill: "#FF6010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBin);
export default __webpack_public_path__ + "static/media/deleteBin.555097439abae76668a8f2bf7090dfd2.svg";
export { ForwardRef as ReactComponent };